import type { DemoKey } from './keys';

export const gu: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'ભૂમિતિ · 3D',
  'panel.figure': 'આકાર',
  'panel.dims': 'પરિમાણ',
  'panel.style': 'દેખાવ',
  'panel.lines': 'વિશેષ રેખાઓ',
  'style.body': 'શરીર',
  'style.line': 'રેખા',
  'style.cut': 'છેદ',
  'style.labels': 'શિરોબિંદુ લેબલ',
  'group.face': 'મુખ વિકર્ણ / જનક',
  'group.space': 'વિકર્ણ / અક્ષ / મધ્યગા',
  'split.label': 'છેદ',
  'btn.animate': 'એનિમેટ',
  'btn.reset': 'રીસેટ',
  'hint.line1': 'ફેરવવા માટે ખેંચો · ઝૂમ માટે સ્ક્રોલ',
  'hint.line2': 'પસંદ કરવા રેખા પર ક્લિક કરો',
  'fig.cuboid': 'ઘનાભ',
  'fig.cube': 'ઘન',
  'fig.triPrism': 'ત્રિકોણ પ્રિઝમ',
  'fig.hexPrism': 'ષટ્કોણ પ્રિઝમ',
  'fig.tetrahedron': 'ચતુષ્ફલક',
  'fig.squarePyramid': 'ચતુષ્કોણ પિરામિડ',
  'fig.cylinder': 'નળાકાર',
  'fig.cone': 'શંકુ',
  'fig.sphere': 'ગોળો',
  'fig.frustumPyramid': 'પિરામિડ છિન્નક',
  'fig.frustumCone': 'શંકુ છિન્નક',
  'dim.length': 'લંબાઈ',
  'dim.width': 'પહોળાઈ',
  'dim.height': 'ઊંચાઈ',
  'dim.side': 'બાજુ',
  'dim.radius': 'ત્રિજ્યા',
  'dim.r1': 'નીચલી ત્રિજ્યા',
  'dim.r2': 'ઉપરી ત્રિજ્યા',
  'dim.sideBase': 'આધાર બાજુ',
  'dim.sideTop': 'ઉપલી બાજુ',
  'info.face': 'મુખ',
  'info.center': 'કેન્દ્રથી',
  'info.diagonal': 'વિકર્ણ',
  'info.axial': 'અક્ષીય વિકર્ણ',
  'info.diameter': 'વ્યાસ',
  'info.generator': 'જનક',
  'info.axis': 'અક્ષ',
  'info.height': 'ઊંચાઈ',
  'info.median': 'મધ્યગા',
  'info.apothem': 'એપોથેમ',
  'info.diameterBase': 'આધાર વ્યાસ',
  'info.diameterTop': 'ઉપલો વ્યાસ',
};
